<template>
  <div class="primary-container">
    <div class="title">
      <img class="title_img"
           src="../../assets/images/03/gongchang_icon.png"
           alt="">
      工厂源管理
    </div>
    <div class="search">
      工厂名称
      <el-input size="small"
                v-model="searchInput"></el-input>
      <!-- <el-button icon="el-icon-search"
                 size="small"
                 type="primary"
                 class="search_btn"
                 @click="handleSearchClick"
                 ></el-button> -->
      <el-button class="search-submit"
                 type="primary"
                 @click="handleSearchClick">
        查询
      </el-button>
      <router-link to="factory/addFactory">
        <el-button type="warning"
                   size="small"
                   class="add_btn">添加</el-button>
      </router-link>

    </div>
    <div class="factory_main">
      <el-table :data="data.result"
                style="width: 100%"
                height="100%">
        <el-table-column class-name="number"
                         label="序号"
                         align="center"
                         type="index"
                         min-width="50"
                         fixed>
        </el-table-column>
        <el-table-column label="工厂名称"
                         min-width="120">
          <template slot-scope="scope">
            <div size="medium">{{scope.row.factoryname}}</div>
          </template>
        </el-table-column>
        <el-table-column label="地址"
                         header-align="center"
                         align="left"
                         min-width="120">
          <template slot-scope="scope">
            <div>{{scope.row.departurename}}{{scope.row.departureaddress}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="lat"
                         label="工厂经度"
                         header-align="center"
                         align="center">
        </el-table-column>
        <el-table-column prop="lng"
                         label="工厂纬度"
                         align="center"
                         header-align="center">
        </el-table-column>
        <el-table-column header-align="center"
                         prop="createDate"
                         label="发布时间"
                         min-width="130"
                         align="center"></el-table-column>
        <el-table-column label="备注"
                         class="operation"
                         header-align="center"
                         align="center"
                         width="120">
          <template slot-scope="scope">
            <el-tooltip class="item update"
                        effect="dark"
                        content="修改"
                        placement="top">
              <el-button @click="handleUpdateClick(scope.row.id)"></el-button>
            </el-tooltip>
            <el-tooltip class="item delete"
                        effect="dark"
                        content="删除"
                        placement="top">
              <el-button @click="handleDeleteClick(scope.row.id)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="pages">
      <span class="demonstartion"> 共{{data.total}}条记录</span>
      <el-pagination @current-change="handleCurrentChange"
                     :page-size="data.pageSize"
                     layout="prev, pager, next"
                     :total="data.total"
                     background>
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { factoryList, deleteFactory } from 'apis/index'
export default {
  name: 'Container',
  data () {
    return {
      searchInput: '',
      data: {}
    }
  },
  methods: {
    getData (name) { // 获取信息
      factoryList({
        factoryname: name || ''
      }).then(res => {
        this.data = res.data.data.factoryList
        // console.log(this.data)
      })
    },
    handleSearchClick () { // 查询
      this.getData(this.searchInput)
    },
    handleUpdateClick (id) { // 修改
      this.$router.push({ path: 'factory/addFactory', query: { item: id } })
    },
    handleCurrentChange (val) {
      let pageNum = val
      factoryList({ pageNum }).then(res => {
        this.data = res.data.data.factoryList
      })
    },
    handleDeleteClick (id) { // 删除
      deleteFactory({ id: id }).then(res => {
        if (res.data.code === 0) {
          for (var i = 0; i < this.data.result.length; i++) { // 从当前列别表中删除该数据
            if (this.data.result[i].id === id) {
              this.data.result.splice(i, 1)
            }
          }
        }
      })
    }
  },
  mounted () {
    this.getData()
  }
}
</script>
<style lang="stylus">
@import '~styles/mixins.styl'
@import '~styles/varibles.styl'
.primary-container
  height 100%
  padding 20px
  .title
    width 100%
    height 46px
    line-height 46px
    color #212832
    border-bottom 1px solid #cfd5dc
    .title_img
      background #9231ff
      border-radius 50%
  .search
    width 100%
    height 40px
    padding-top 10px
    .el-input
      margin-left 10px
      width 210px
    .search_btn
      width 64px
      margin-left 30px
    .search-submit
      padding 5px 20px
      background #fff
      margin-left 30px
      font-size 12px
      text-align right
      color $bgColor
      &:hover
        background $bgColor
        color #fff
    .add_btn
      addBtn()
      margin-right 20px
      float right
  .factory_main
    height calc(100% - 180px)
    overflow hidden
  .el-table
    th
      background #e7f0f8
      .cell
        height 25px
        line-height 25px
    td
      .cell
        line-height 20px
        size12()
        .el-button
          padding 6px 14px
          width 28px
          cursor pointer
          height 28px
          margin 0 8px
          &.update
            update()
          &.unblocked
            unblocked()
          &.delete
            delete()
.el-pagination
  color #5e656f
  font-weight 100
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li
  background transparent
  border 1px solid #cfd5dc
.pages
  margin-top 15px
  .demonstartion
    float right
    line-height 45px
    color #5e656f
</style>
